export function getLocalStorage(key, defaultValue){
    try {
        const item = localStorage.getItem(key);
        if (item === null) return defaultValue;

        try {
            return JSON.parse(item);
        } catch {
            // Return raw string if it wasn't JSON
            return item;
        }
    } catch (error) {
        return defaultValue;
    }
}

export function setLocalStorage(key, value){
    try {
        // Convert objects and booleans to JSON strings automatically
        const valueToStore = typeof value === 'object' ? JSON.stringify(value) : value;
        localStorage.setItem(key, valueToStore);
    } catch (error) {
    }
}

export function removeFromLocalStorage(key){
    try {
        localStorage.removeItem(key)
    } catch(error) {
        
    }
}